import * as types from '../constants/actionTypes'

export const receiveOrdersData = (data) => (
  {
    type: types.RECEIVE_ORDERS_DATA,
    data
  }
)

export const setAnalyticsDatesRange = (datesRange) => (
  {
    type: types.SET_ANALYTICS_DATES_RANGE,
    datesRange
  }
)



// WEBPACK FOOTER //
// ./src/actions/shopifyAnalyticsAC.js